import {Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
  flatMap,
  UIArtefakt,
  WertelisteElementKrankheit
} from '../../../models/uiArtefakt';
import {BehaviorSubject, interval, Observable, Subject, Subscription} from 'rxjs';
import {EventService} from '../../../services/event.service';
import {NgForm} from '@angular/forms';
import {ValidationService} from '../../../services/validation.service';
import {filter, takeWhile, tap} from 'rxjs/operators';
import {ThemeService, TranslationService} from '@lv1871/core';

export class ModulDialogInput {
  item: WertelisteElementKrankheit;
  modul$: Observable<UIArtefakt>;
}

@Component({
    selector: 'lv-modul-dialog',
    templateUrl: './modul-dialog.component.html',
    styleUrls: ['./modul-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ModulDialogComponent implements OnInit, OnDestroy {
  @ViewChild(NgForm, {static: true})
  private _ngForm;

  public uiModul$: Observable<UIArtefakt>;
  public modulArtefakte: UIArtefakt[];
  public uiControlsRequestPending: boolean;
  public showSpinner$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _uiControlsRequestPendingSubscription$ = Subscription.EMPTY;
  private _uebernehmenClickedSubscription$ = Subscription.EMPTY;
  private _uebernehmenClicked$ = new Subject<boolean>();

  constructor(public dialogRef: MatDialogRef<ModulDialogComponent>,
              private _eventService: EventService, private _validationService: ValidationService,
              private _translationService: TranslationService, private _themeService: ThemeService,
              @Inject(MAT_DIALOG_DATA) public data: ModulDialogInput) {
  }

  public ngOnInit(): void {
    this._uiControlsRequestPendingSubscription$ = this._eventService.uiControlsRequestPending$.
      subscribe(requestPending => this.uiControlsRequestPending = requestPending);
    this.uiModul$ = this.data.modul$.pipe(tap(resp => {
      this.modulArtefakte = resp.UIArtefakt;
    }));

    this._themeService.setApplicationTheme(
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-primary'),
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-secondary'),
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-warn'), null,
        'mdc-dialog__container'
    );

    this._uebernehmenClickedSubscription$ = this._uebernehmenClicked$.pipe(
        tap(_ => {
          if (!this.uiControlsRequestPending) {
            const childs = flatMap(this.modulArtefakte);
            this._validationService.validateForms(childs);
            if (this._validationService.isArtefakteValid(childs)) {
              this.dialogRef.close(true);
            }
          }
        }),
        tap(_ => this.showSpinner$.next(false))
    ).subscribe();
  }

  public ngOnDestroy(): void {
    if (this._uebernehmenClickedSubscription$) {
      this._uebernehmenClickedSubscription$.unsubscribe();
    }
    if (this._uiControlsRequestPendingSubscription$) {
      this._uiControlsRequestPendingSubscription$.unsubscribe();
    }
  }

  public closeDialog(): void {
    this.dialogRef.close(false);
  }

  public onUebernehmenClicked() {
    if (this.showSpinner$.getValue()) {
      return;
    }
    interval(100).pipe(
        tap(_ => this.showSpinner$.next(true)),
        filter(_ => !this.uiControlsRequestPending),
        tap(_ => this._uebernehmenClicked$.next(true)),
        takeWhile(() => this.uiControlsRequestPending)).subscribe();
  }
}
